// extracted by mini-css-extract-plugin
module.exports = {"root":"WishList_root__GURdq","emptyContainer":"WishList_emptyContainer__SoKLc","shareWishlistBtn":"WishList_shareWishlistBtn__89u9L"};